var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearnerListsIconOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_1497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.21949 10.8049C7.21949 11.1464 7.64632 11.4025 8.07315 11.4025H15.9268C16.3536 11.4025 16.7805 11.1464 16.7805 10.8049C16.7805 10.3781 16.3536 10.122 15.9268 10.122H8.07315C7.64632 10.122 7.21949 10.3781 7.21949 10.8049ZM15.9268 16.3537H8.07315C7.64632 16.3537 7.21949 16.6951 7.21949 17.0366C7.21949 17.3781 7.64632 17.7195 8.07315 17.7195H15.9268C16.3536 17.7195 16.7805 17.3781 16.7805 17.0366C16.7805 16.6951 16.3536 16.3537 15.9268 16.3537ZM7.21949 13.8781C7.21949 14.3049 7.64632 14.561 8.07315 14.561H15.9268C16.3536 14.561 16.7805 14.3049 16.7805 13.8781C16.7805 13.5366 16.3536 13.2805 15.9268 13.2805H8.07315C7.64632 13.2805 7.21949 13.5366 7.21949 13.8781ZM19.939 7.98782C19.8536 7.56099 19.6829 7.21952 19.3414 6.87806L14.7317 2.60977C14.3902 2.2683 13.9634 2.09757 13.4512 2.01221H6.36583C5.08534 2.01221 3.97559 2.95123 3.97559 4.23172V11.1464V19.8537C4.06095 21.0488 5.08534 21.9878 6.36583 21.9878H17.6341C18.9146 21.9878 20.0244 20.9634 20.0244 19.7683V8.15855L19.939 7.98782ZM17.9756 7.47562H14.9878C14.4756 7.47562 14.0488 7.04879 14.0488 6.62196V3.89026L17.9756 7.47562ZM18.5731 19.7683C18.5731 20.2805 18.1463 20.622 17.6341 20.622H6.36583C5.85363 20.622 5.51217 20.2805 5.42681 19.8537V11.1464V4.23172C5.42681 3.71952 5.85363 3.29269 6.36583 3.29269H12.6829V6.62196C12.6829 7.81709 13.7073 8.84148 14.9878 8.84148H18.5731V19.7683Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_1497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnerListsIconOn);
export default __webpack_public_path__ + "static/media/LearnerListsIconOn.42239d6c94165651fc3015c7df33b9f7.svg";
export { ForwardRef as ReactComponent };